import styled from 'styled-components';

export const Button = styled.a`
  svg {
    vertical-align: middle;
    margin-right: 10px;
  }
`;
